import {UIGameFeedView} from '../../../../shared/scripts/ui_game/ui_game_feed/UIGameFeedView'

export class UIMGameFeedView extends UIGameFeedView {
    protected setSize(w: number, h: number) {
        this.gameChat.scale(1)
        this.gameLog.scale(1)
    }

    protected setPosition(canvasX: number, canvasY: number) {
        const heightOfMyPlayerView = this.uiGameManager.canvasController.bottomViewHeight
        if(this.uiGameManager.replayView) {
            const topOfReplayView = this.uiGameManager.replayView.mainBlock.clientHeight + heightOfMyPlayerView
            this.gameChat.setPositionBottom(topOfReplayView)
            this.gameLog.setPositionBottom(topOfReplayView)
        } else {
            this.gameChat.setPositionBottom(heightOfMyPlayerView)
            this.gameLog.setPositionBottom(heightOfMyPlayerView)
        }
    }
}
